import { render, staticRenderFns } from "./btnDownload.vue?vue&type=template&id=2437b17e&"
import script from "./btnDownload.vue?vue&type=script&lang=js&"
export * from "./btnDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports